import { Link } from "react-router-dom";

interface Props {
  title: string;
  subtitle?: string;
  to?: string;
  linkLabel?: string;
}

export default function SectionHeader({ title, subtitle, to, linkLabel = "查看全部" }: Props) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div className="min-w-0">
        <h2 className="flex items-center gap-2.5 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
          <span className="h-5 w-1.5 rounded-full bg-accent-500 md:h-6"></span>
          {title}
        </h2>
        {subtitle ? <p className="mt-2 pl-4 text-xs text-foreground-600 md:text-sm">{subtitle}</p> : null}
      </div>
      {to ? (
        <Link
          to={to}
          className="group flex cursor-pointer items-center gap-1 whitespace-nowrap text-xs text-foreground-600 transition-colors hover:text-primary-600 md:text-sm"
        >
          {linkLabel}
          <i className="ri-arrow-right-s-line text-base transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
        </Link>
      ) : null}
    </div>
  );
}